<template>
	<div class="ui-html-page__block">
		<!-- Интро: заголовок + медиа (видео/iframe/картинка) -->
		<div v-if="hasIntro" class="ui-html-page-intro">
			<div v-if="parsed.title" class="ui-html-page__block--title">
				{{ parsed.title }}
			</div>

			<!-- Видео (iframe) -->
			<iframe
				v-if="media && media.type === 'iframe'"
				:src="media.src"
				class="embedded-video"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowfullscreen
			/>

			<!-- Видео (file/mp4 и т.п.) -->
			<video
				v-else-if="media && media.type === 'video'"
				:src="media.src"
				:poster="media.poster"
				class="embedded-video"
				controls
			/>

			<!-- Картинка -->
			<img
				v-else-if="media && media.type === 'image'"
				:src="media.src"
				:alt="imageAlt"
				class="embedded-image"
				loading="lazy"
				decoding="async"
			>
		</div>

		<!-- Контент -->
		<div
			v-if="parsed.content"
			class="ui-html-page__block--content ql-editor"
			v-html="parsed.content"
		/>

		<!-- Fallback: если html не JSON -->
		<div v-else-if="html" class="ui-html-page__block--content ql-editor" v-html="html" />

		<slot v-else name="html" />
	</div>
</template>

<script>
export default {
	name: 'UiHtmlPage',
	props: {
		title: String,
		html: String
	},

	computed: {
		parsed() {
			// Пытаемся распарсить JSON. Считаем «нашим» форматом, если есть
			// любой из ожидаемых ключей: title/content/video/image.
			try {
				const obj = JSON.parse(this.html || '{}');
				if (obj && (obj.content || obj.title || obj.video || obj.image)) {
					return obj;
				}
				return { title: this.title, content: this.html };
			} catch {
				return { title: this.title, content: this.html };
			}
		},

		media() {
			// Нормализуем поля video/image (могут быть строкой или объектом с link/url/src)
			const videoLink = this.normalizeFileField(this.parsed.video);
			const imageLink = this.normalizeFileField(this.parsed.image);

			if (videoLink) {
				return {
					type: this.isIframe(videoLink) ? 'iframe' : 'video',
					src: videoLink,
					poster: this.parsed?.poster ? this.normalizeFileField(this.parsed.poster) : null,
				};
			}
			if (imageLink) {
				return { type: 'image', src: imageLink };
			}
			return null;
		},

		hasIntro() {
			return Boolean(this.parsed?.title || this.media?.src);
		},

		imageAlt() {
			// Красивый alt для картинки
			const img = this.parsed?.image;
			if (img && typeof img === 'object') {
				return img.alt || img?.file?.name || 'image';
			}
			return 'image';
		}
	},

	methods: {
		isIframe(url) {
			return typeof url === 'string' && (
				url.includes('embed') ||
				url.includes('youtube') ||
				url.includes('rutube') ||
				url.includes('vimeo')
			);
		},
		normalizeFileField(val) {
			// Поддерживаем строку и объект разных форм: { link }, { url }, { src }
			if (!val) return '';
			if (typeof val === 'string') return val;
			if (typeof val === 'object') {
				return val.link || val.url || val.src || '';
			}
			return '';
		}
	}
};
</script>
